<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-overlay :value="!loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <strong>Note: If any data is not available or applicable, kindly mention NA.</strong>

        <v-form id="subject_reg" @submit.prevent="submit" v-model="isValid">
            <br>
            <v-row dense justify="center">
                <v-col cols="10">
                    <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" />
                </v-col>
            </v-row>

            <v-card class="pa-4 mt-3">
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title>Compulsory Subjects</v-toolbar-title>
                </v-toolbar>
                <v-row>
                    <v-col v-for="subject in scholasticSubjects" :key="subject.id" cols="auto">
                        <v-checkbox :disabled="true" class="text-blue" v-model="selectedSubjects11" :value="subject.id"
                            :label="subject.course_name"></v-checkbox>
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="pa-4 mt-3">
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title>Internal Graded Compulsory Subjects</v-toolbar-title>
                </v-toolbar>
                <v-row>
                    <v-col v-for="subject in coScholasticSubjects" :key="subject.id" cols="auto">
                        <v-checkbox :disabled="true" class="text-blue" v-model="selectedSubjects22" :value="subject.id"
                            :label="subject.course_name"></v-checkbox>
                    </v-col>
                </v-row>
            </v-card>

            <!-- Core Elective Subject 1 -->
            <v-card class="pa-4 mt-3">
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title> Core Elective Subject 1 <span style="font-weight: 900;"> applicable for Science Stream only </span>(Select Any One From
                        Biology And Mathematics)</v-toolbar-title>
                </v-toolbar>
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="selectedELSubject1new" :items="filteredELSubjects1" item-text="course_name"
                            item-value="id" label="Select Subject" dense outlined :disabled="application_form_standard === 'XI (Humanities)'"></v-select>
                    </v-col>
                </v-row>
            </v-card>

            <!-- Elective Subject 2 -->
            <v-card class="pa-4 mt-3">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title>Elective Subject 2 (<span style="font-weight: 900;">Select Any One </span> Except Artificial Intelligence, Financial Markets Management for <span style="font-weight: 900;"> Commerce and Science Stream </span>) <br>
                                    <span style="margin-left: 163px;">(<span style="font-weight: 900;">Select Any Two </span> Except Artificial Intelligence, Financial Markets Management for <span style="font-weight: 900;"> Humanities Stream </span>)</span></v-toolbar-title>
                </v-toolbar>
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="4">
                        <v-icon color="red">*</v-icon>
                        <v-select
                            v-model="selectedELSubject2new"
                            :items="filteredELSubjects2"
                            item-text="course_name"
                            item-value="id"
                            label="Select Subject"
                            multiple
                            chips
                            :rules="[validateSubjects]"
                            :item-disabled="item => selectedELSubject2new.length >= maxSelection && !selectedELSubject2new.includes(item.id)"
                            dense
                            outlined
                        ></v-select>
                    </v-col>
                </v-row>
            </v-card>

            <!-- Skill Subject (Optional) -->
            <v-card class="pa-4 mt-3">
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title> Skill Subject ( <span style="font-weight: 900;">Optional </span> - Select any one from Artificial Intelligence or Financial
                        Markets Management)</v-toolbar-title>
                </v-toolbar>
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="4">
                        <v-select v-model="selectedELSubject3new" :items="filteredELSubjects3" item-text="course_name"
                            item-value="id" label="Select Subject" dense outlined></v-select>
                    </v-col>
                </v-row>
            </v-card>
            <br>
            <div>
                <p class="note">
                    <span class="note-icon">⭐</span>
                    <strong>Note - 1:</strong> Mandatory to select one or two subjects from the drop-down as per the instructions given in the bracket.
                </p>
                <p class="note">
                    <span class="note-icon">⭐</span>
                    <strong>Note - 2:</strong> For any elective subject, a minimum of 8 students must avail the same
                    subject from the list of available subjects.
                    If less than eight students select a particular elective subject, it may not be offered by the
                    school due to insufficient enrollments.
                </p>
            </div>

            <br>
            <v-row justify="center" dense class="mt-4">
                <v-col cols="10">
                    <div style="text-align: center;">
                        <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
                            :disabled="!isValid || selectedELSubject2new.length === 0">Save</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            subjects: {
                Compulsory_Scholastic: [],
                Compulsory_CoScholastic: [],
                EL: []
            },
            selectedSubjects: [],
            selectedSubjects11: [],
            selectedSubjects22: [],
            selectedELSubject1: null,
            selectedELSubject2: null,
            selectedELSubject3: null,
            selectedELSubject1new: "",
            selectedELSubject2new: [],
            selectedELSubject3new: "",
            application_form_standard:"",
            loader: false,
            isValid: true,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            application_form_data: {
                admission_form_no: "",
                admission_form_id: ""
            },
            tenant: "wws",
            user_type: null,
            isHumanities: false,
            maxSelection: 1,
        };
    },
    computed: {
        scholasticSubjects() {
            return this.subjects.Compulsory_Scholastic || [];
        },
        coScholasticSubjects() {
            return this.subjects.Compulsory_CoScholastic || [];
        },
        // Filter EL Subjects for the first select
        filteredELSubjects1() {
            return this.subjects.EL;
        },
        // Filter EL Subjects for the second select (remove first selection)
        filteredELSubjects2() {
            return this.subjects.EL.filter(sub => sub.id !== this.selectedELSubject1new || sub.course_name == 'NA:NA');
        },
        // Filter EL Subjects for the third select (remove first & second selection)
        filteredELSubjects3() {
            return this.subjects.EL.filter(sub => (sub.id !== this.selectedELSubject1new && !this.selectedELSubject2new.includes(sub.id)) || sub.course_name === 'NA:NA');
        }
    },
    methods: {
        setSelectionLimit() {
            if (this.isHumanities) {
            this.maxSelection = 2
            } else {
            this.maxSelection = 1
            }
        },
        validateSubjects(v) {
           if (!v || v.length === 0) return true;

            if (this.isHumanities) {
                return v.length === 2 || "Select exactly 2 subjects for Humanities"
            }

            return v.length <= 1 || "Only 1 subject allowed for Science/Commerce"
        },
        getform() {
            axios.post("/admissionForm/subjectRegistrationDetailsSBPPS", this.application_form_data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        const data = res.data.registered_subjects;
                        this.isHumanities = res.data.isHumanities;
                        this.subjects = {
                            Compulsory_Scholastic: data.Compulsory_Scholastic || [],
                            Compulsory_CoScholastic: data.Compulsory_CoScholastic || [],
                            EL: data.EL || []
                        };
                        this.application_form_standard = res.data.application_form_standard_name;
                        // Extract all compulsory subject IDs
                        const compulsorySubjectIds = [
                            ...this.subjects.Compulsory_Scholastic.map(sub => sub.id),
                            ...this.subjects.Compulsory_CoScholastic.map(sub => sub.id)
                        ];

                        // Ensure compulsory subjects are always selected
                        this.selectedSubjects = [
                            ...new Set([
                                ...compulsorySubjectIds, // Add all compulsory subjects
                                ...res.data.registered_subjects_data // Include registered subjects
                            ])
                        ];
                        for (var x in data.Compulsory_Scholastic) {
                            this.selectedSubjects11.push(data.Compulsory_Scholastic[x].id)
                        }
                        for (var x in data.Compulsory_CoScholastic) {
                            this.selectedSubjects22.push(data.Compulsory_CoScholastic[x].id)
                        }
                        // Preselect elective subjects in dropdowns
                        let elIds = this.selectedSubjects.filter(id =>
                        this.subjects.EL.some(sub => sub.id === id)
                        );

                        this.selectedELSubject1new = elIds.length ? elIds[0] : null;
                        this.selectedELSubject3new = elIds.length > 1 ? elIds[elIds.length - 1] : null;
                        this.selectedELSubject2new = elIds.slice(1, -1);
                        this.$store.commit("setform_progress", res.data.form_progress);
                        this.setSelectionLimit()
                    } else {
                        this.showSnackbar("red", res.data.message);
                        this.$store.commit("setform_progress", res.data.form_progress);
                    }
                })
                .catch((error) => console.error(error))
                .finally(() => this.loader = true);
        },
        submit() {
            this.loader = false;
            // Ensure selectedELSubjects are added to selectedSubjects
            var main_array = [];
            for (var x in this.selectedSubjects11) {
                main_array.push(this.selectedSubjects11[x])
            }
            for (var x in this.selectedSubjects22) {
                main_array.push(this.selectedSubjects22[x])
            }
            main_array.push(this.selectedELSubject1new);
            main_array.push(...this.selectedELSubject2new); 
            main_array.push(this.selectedELSubject3new);
            var flag = 0
            axios.post("/admissionForm/saveSubjectRegistrationDetailsSBPPS", {
                admission_form_id: this.application_form_data.admission_form_id,
                admission_form_no: this.application_form_data.admission_form_no,
                selected_subjects: main_array
            })
                .then(res => {
                    if (res.data.form_saved === "YES") {
                        this.showSnackbar("#4caf50", "Saved Successfully... Click on Next tab to Continue");
                    } else {
                        this.showSnackbar("red", res.data.message);
                    }
                    this.loader = true;
                    this.$store.commit("setform_progress", res.data.form_progress);
                })
                .catch(error => console.error(error));
        },
        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color;
            this.snackbar_msg = msg;
        }
    },
    mounted() {
        this.application_form_data = this.$store.getters.application_form_data;
        this.getform();
    }
};
</script>

<style scoped>
.note {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #333;
    background: #f8f8f8;
    padding: 10px;
    border-left: 4px solid #007bff;
}
</style>
